/* tslint:disable */

declare var Object: any;
export interface TopicCommentReportInterface {
  "topicCommentReportTypeId": number;
  "topicCommentId": number;
  "content"?: string;
  "response"?: string;
  "languageCode"?: string;
  "createdAt"?: Date;
  "createdBy"?: number;
  "updatedAt"?: Date;
  "updatedBy"?: number;
  "id"?: number;
}

export class TopicCommentReport implements TopicCommentReportInterface {
  "topicCommentReportTypeId": number;
  "topicCommentId": number;
  "content": string;
  "response": string;
  "languageCode": string;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  constructor(data?: TopicCommentReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TopicCommentReport`.
   */
  public static getModelName() {
    return "TopicCommentReport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TopicCommentReport for dynamic purposes.
  **/
  public static factory(data: TopicCommentReportInterface): TopicCommentReport{
    return new TopicCommentReport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TopicCommentReport',
      plural: 'TopicCommentReports',
      path: 'TopicCommentReports',
      idName: 'id',
      properties: {
        "topicCommentReportTypeId": {
          name: 'topicCommentReportTypeId',
          type: 'number'
        },
        "topicCommentId": {
          name: 'topicCommentId',
          type: 'number'
        },
        "content": {
          name: 'content',
          type: 'string'
        },
        "response": {
          name: 'response',
          type: 'string'
        },
        "languageCode": {
          name: 'languageCode',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
